import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-biosync py-10 px-5 sm:px-10 text-center" data-id="element-304">
      <div className="max-w-[1100px] mx-auto" data-id="element-305">
        <h2 className="text-white font-bold text-3xl sm:text-4xl md:text-[36px] leading-tight mb-6 max-w-3xl mx-auto" data-id="element-306">
          "¿Cuánto tiempo más vas a esperar que el silencio emocional se
          convierta en distancia real?"
        </h2>
        <p className="text-white/90 text-lg sm:text-xl max-w-2xl mx-auto" data-id="element-307">
          "El problema no se resuelve solo.
          <br data-id="element-308" />
          Pero sí tiene solución.
          <br data-id="element-309" />Y está disponible hoy."
        </p>
      </div>
    </section>;
};